import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { updateSim } from "./sims";

const initialState = {
  customFieldValues: [],
};

const customFieldValuesSlice = createSlice({
  name: "customFieldValues",
  initialState,
  reducers: {
    setCustomFieldValues(state, action) {
      state.customFieldValues = action.payload;
    },
  },
});

export function getSimCustomFieldValues({ sim_id }) {
  return async (dispatch) => {
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/customFieldValue/sim/${sim_id}`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        customFieldValuesSlice.actions.setCustomFieldValues(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function updateSimCustomFieldValues({ sim_ids, values }) {
  return async (dispatch) => {
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const data = {
        simIds: sim_ids,
        customFieldValues: values,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/customFieldValue/sim`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(updateSim(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export default customFieldValuesSlice.reducer;
